import { getActiveNetwork } from '@/lib/network/active';

/**
 * Build a Solscan transaction URL for the given signature on the user's
 * active network. Mainnet returns the bare URL; devnet appends
 * `?cluster=devnet`.
 */
export function getSolscanTxUrl(signature: string): string {
  const base = `https://solscan.io/tx/${signature}`;
  if (getActiveNetwork() === 'mainnet') {
    return base;
  }
  return `${base}?cluster=devnet`;
}
